webpackJsonp([10],{

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(53)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 62:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_index_js__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      files: [],
      router: __WEBPACK_IMPORTED_MODULE_1__router_index_js__["a" /* default */],
      search: '',
      fileTitle: '',
      dialog: false,
      dialog2: [],
      tags: ['Draft', 'Final', 'Image', 'Agenda', 'Presentation', 'Background', 'General', 'Notes', 'Other'],
      tag: null,
      tagFilters: [],
      fileName: '',
      final: false,
      filteredFiles: []
    };
  },

  watch: {
    files: function files(_files) {
      this.filteredFiles = _files;
    },
    tagFilters: function tagFilters(filters) {
      var _this = this;

      if (this.tagFilters.length === 0 || this.final === false) {
        this.filteredFiles = this.files;
      } else {
        var filtered = this.files.filter(function (file) {
          for (var i = 0; i < file.tags.length; i++) {
            if (_this.tagFilters.includes(file.tags[i])) {
              return true;
            }
          }
          return false;
        });
        this.filteredFiles = filtered;
      }
    }
  },
  computed: {
    searchedFiles: function searchedFiles() {
      var _this2 = this;

      if (this.tagFilters.length === 0 || this.final === false) {
        this.filteredFiles = this.files;
      }
      return this.filteredFiles.filter(function (file) {
        return file.title.toLowerCase().includes(_this2.search.toLowerCase());
      });
    }
  },
  methods: {
    pushProject: function pushProject(projectID) {
      this.$store.dispatch('Project', projectID);
      __WEBPACK_IMPORTED_MODULE_1__router_index_js__["a" /* default */].push('/project/' + projectID);
    },
    imageSelected: function imageSelected(e) {
      this.newFile = e.target.files[0];
    },
    deletes: function deletes(file) {
      var _this3 = this;

      file.fileDialog = false;
      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(this.$store.getters.user.id).collection('files').get().then(function (querySnapshot) {
        querySnapshot.forEach(function (docu) {
          if (file.fileURL === docu.data().file.fileURL) {
            __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(_this3.$store.getters.user.id).collection('files').doc(docu.id).delete();
          }
        });
      });
      var filteredAry = this.files.filter(function (e) {
        return e !== file;
      });
      this.files = filteredAry;
    },
    newFileTime: function newFileTime() {
      var tagg = this.tag == null ? [] : this.tag;
      var char = [0, this.newFile, 0, this.fileTitle, this.$store.getters.user.id, tagg];
      this.fileTitle = '';
      this.$store.dispatch('newFile', char);
      this.dialog = false;
      this.pullUserFiles();
    },
    funct: function funct(projectID) {
      this.$store.dispatch('Project', projectID);
      this.$router.push('/project/' + projectID);
    },
    pullUserFiles: function pullUserFiles() {
      var _this4 = this;

      this.files = [];
      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(this.$store.getters.user.id).collection('files').get().then(function (querySnapshot) {
        querySnapshot.forEach(function (docu) {
          var file = {
            title: docu.data().file.title,
            fileURL: docu.data().file.fileURL,
            projectID: 0,
            delete: true,
            tags: docu.data().file.tags
          };
          _this4.files.push(file);
        });
      });
      __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(this.$store.getters.user.id).collection('projects').get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var projectID = doc.data().projectID;
          __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(projectID).get().then(function (docu) {
            if (docu.data().files.length !== 0) {
              for (var i = 0; i < docu.data().files.length; i++) {
                var file = {
                  title: docu.data().files[i].title,
                  fileURL: docu.data().files[i].fileURL,
                  projectID: projectID,
                  delete: false,
                  fileDialog: false,
                  tags: docu.data().files[i].tags
                };
                _this4.files.push(file);
              }
            }
          });
        });
      });
    }
  },
  beforeCreate: function beforeCreate() {
    var _this5 = this;

    __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(this.$store.getters.user.id).collection('files').get().then(function (querySnapshot) {
      querySnapshot.forEach(function (docu) {
        var file = {
          title: docu.data().file.title,
          fileURL: docu.data().file.fileURL,
          projectID: 0,
          delete: true,
          tags: docu.data().file.tags
        };
        _this5.files.push(file);
      });
    });
    __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').doc(this.$store.getters.user.id).collection('projects').get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var projectID = doc.data().projectID;
        __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('projects').doc(projectID).get().then(function (docu) {
          if (docu.data().files.length !== 0) {
            for (var i = 0; i < docu.data().files.length; i++) {
              var file = {
                title: docu.data().files[i].title,
                fileURL: docu.data().files[i].fileURL,
                projectID: projectID,
                delete: false,
                fileDialog: false,
                tags: docu.data().files[i].tags
              };
              _this5.files.push(file);
            }
          }
        });
      });
    });
  }
});

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('div', {
    staticClass: "primary"
  }, [_c('v-subheader', {
    staticClass: "deliverable",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "8ex",
      "max-height": "8ex"
    },
    attrs: {
      "src": "/static/img/official_icons/deliverable.png"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "deliverable",
    staticStyle: {
      "color": "white",
      "psition": "relative",
      "bottom": "10px"
    }
  }, [_vm._v("Document Library\n      ")])])], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "box": "",
      "placeholder": "Search a library..."
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Filter By Tag"
    },
    model: {
      value: (_vm.final),
      callback: function($$v) {
        _vm.final = $$v
      },
      expression: "final"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.final),
      expression: "final"
    }],
    attrs: {
      "items": _vm.tags,
      "box": "",
      "chips": "",
      "color": "blue-grey lighten-2",
      "label": "Select Tags to Filter By",
      "item-text": "name",
      "item-value": "name",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          staticClass: "chip--select-multi",
          attrs: {
            "selected": data.selected,
            "close": ""
          },
          on: {
            "input": function($event) {
              data.parent.selectItem(data.item)
            }
          }
        }, [_vm._v("\n                              " + _vm._s(data.item) + "\n                            ")])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item)
          }
        })], 1)]]
      }
    }]),
    model: {
      value: (_vm.tagFilters),
      callback: function($$v) {
        _vm.tagFilters = $$v
      },
      expression: "tagFilters"
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "scroll-y",
    attrs: {
      "row": "",
      "wrap": "",
      "id": "scroll-target"
    }
  }, _vm._l((_vm.searchedFiles), function(file) {
    return _c('v-flex', _vm._b({
      directives: [{
        name: "scroll",
        rawName: "v-scroll:#scroll-target",
        arg: "#scroll-target"
      }],
      key: file.fileURL,
      attrs: {
        "align-center": "",
        "justify-center": ""
      }
    }, 'v-flex', ( _obj = {}, _obj["xs3"] = true, _obj ), false), [_c('v-card', {
      staticStyle: {
        "height": "19em",
        "max-width": "260px",
        "min-width": "200px"
      },
      attrs: {
        "color": "grey lighten-2"
      }
    }, [_c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [(file.title.length < 14) ? _c('h4', {
      staticClass: " headline mb-0",
      staticStyle: {
        "display": "block"
      }
    }, [_c('h3', {
      staticClass: " headline mb-0"
    }, [_vm._v(_vm._s(file.title))]), _vm._v(" "), _c('br'), _vm._v(" "), (file.tags.length !== 0) ? _c('h5', [_vm._v("Tags: "), _vm._l((file.tags), function(tag) {
      return [_c('h5', {
        key: tag,
        staticStyle: {
          "font-size": "13px"
        }
      }, [_vm._v(_vm._s(tag) + " ")])]
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (file.title.length > 14) ? _c('h4', {
      staticClass: " headline mb-0",
      staticStyle: {
        "display": "block"
      }
    }, [_c('h3', {
      staticClass: " headline mb-0"
    }, [_vm._v(_vm._s(file.title.substring(0, 14)) + "...")]), _vm._v(" "), _c('br'), _vm._v(" "), (file.tags.length !== 0) ? _c('h5', [_vm._v("Tags: "), _vm._l((file.tags), function(tag) {
      return [_c('h5', {
        key: tag,
        staticStyle: {
          "font-size": "13px"
        }
      }, [_vm._v(_vm._s(tag) + " ")])]
    })], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('v-card-actions', {
      staticStyle: {
        "position": "absolute",
        "bottom": "0px"
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "green",
        "dark": ""
      },
      on: {
        "click": function($event) {
          this.window.open(file.fileURL)
        }
      }
    }, [_vm._v("\n            Open\n          ")]), _vm._v(" "), (file.projectID !== 0) ? _c('v-btn', {
      attrs: {
        "color": "primary",
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.funct(file.projectID)
        }
      }
    }, [_vm._v("\n            Go to Project\n          ")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
      model: {
        value: (file.fileDialog),
        callback: function($$v) {
          _vm.$set(file, "fileDialog", $$v)
        },
        expression: "file.fileDialog"
      }
    }, [(file.delete === true) ? _c('v-btn', {
      attrs: {
        "slot": "activator",
        "color": "alerts",
        "dark": ""
      },
      slot: "activator"
    }, [_vm._v("\n            Delete\n          ")]) : _vm._e(), _vm._v(" "), _c('v-card', {
      staticStyle: {
        "width": "100%",
        "height": "150px"
      }
    }, [_c('v-card-title', [_c('h2', [_vm._v(" You want to delete the File: " + _vm._s(file.title) + "?")])]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "alerts",
        "flat": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.deletes(file)
        }
      }
    }, [_vm._v("\n                    Delete\n                  ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "green",
        "flat": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          file.fileDialog = false
        }
      }
    }, [_vm._v("\n                    Cancel\n                  ")])], 1)], 1)], 1)], 1)], 1)
    var _obj;
  }))], 1)], 1), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "selectedFile",
      "name": "fileName",
      "value": "fileName"
    },
    on: {
      "change": _vm.imageSelected
    }
  }), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "onclick": "document.getElementById('selectedFile').click();"
    },
    slot: "activator"
  }, [_vm._v("\n            Upload Document\n          ")]), _vm._v(" "), _c('v-card', {
    staticClass: "deliverable pa-3 ma-3",
    staticStyle: {
      "height": "300px"
    }
  }, [_c('v-subheader', [_c('h1', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(" Upload A Document ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.fileName))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Document Title",
      "required": ""
    },
    model: {
      value: (_vm.fileTitle),
      callback: function($$v) {
        _vm.fileTitle = $$v
      },
      expression: "fileTitle"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.tags,
      "box": "",
      "chips": "",
      "color": "blue-grey lighten-2",
      "label": "Select Tags for your Document",
      "item-text": "name",
      "item-value": "name",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          staticClass: "chip--select-multi",
          attrs: {
            "selected": data.selected,
            "close": ""
          },
          on: {
            "input": function($event) {
              data.parent.selectItem(data.item)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(data.item) + "\n                ")])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item)
          }
        })], 1)]]
      }
    }]),
    model: {
      value: (_vm.tag),
      callback: function($$v) {
        _vm.tag = $$v
      },
      expression: "tag"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "green",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.newFileTime()
      }
    }
  }, [_vm._v("Submit ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel ")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.4e24e5cbb179b69bc6dd.js